export const GET_BIKE_DATA = "GET_BIKE_DATA";
export const GET_BIKE_DATA_ERROR = "GET_BIKE_DATA_ERROR";
